/**
 * visibilityWatcher — visibilitychange 监听(纯逻辑, 可移植)。
 * 基座: 前端权益刷新设计 §5
 * 用户从 Creem 标签页切回时触发刷新, 防抖: 同一 visible 事件只触发一次。
 */
export function startVisibilityWatcher(onVisible: () => void): () => void {
	let triggered = false;
	const handler = () => {
		if (document.visibilityState === "visible" && !triggered) {
			triggered = true;
			onVisible();
			// 重置标记, 允许下次切回再触发
			setTimeout(() => {
				triggered = false;
			}, 1000);
		}
	};
	document.addEventListener("visibilitychange", handler);
	return () => document.removeEventListener("visibilitychange", handler);
}
